import genericRule from '../../namespace/relation/doingNew_namespace_relation';

export default {
    ...genericRule,
    excludedNamespaceRelations: [],
    namespace: 'application',
    relation: 'reset'
};
